import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchCoreIndustry,
  addCoreIndustry,
  updateCoreIndustry,
  deleteCoreIndustry,
} from "./CoreIndustryAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

// Fetch Async
export const fetchCoreIndustryAsync = createAsyncThunk(
  "coreIndustry/fetch",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchCoreIndustry();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Add Async
export const addCoreIndustryAsync = createAsyncThunk(
  "coreIndustry/add",
  async (newCoreIndustry, { rejectWithValue }) => {
    try {
      return await addCoreIndustry(newCoreIndustry);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update Async
export const updateCoreIndustryAsync = createAsyncThunk(
  "coreIndustry/update",
  async ({ uuid, coreIndustryData }, { rejectWithValue }) => {
    try {
      return await updateCoreIndustry(uuid, coreIndustryData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete Async
export const deleteCoreIndustryAsync = createAsyncThunk(
  "coreIndustry/delete",
  async (id, { rejectWithValue }) => {
    try {
      return await deleteCoreIndustry(id);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Redux Slice
const CoreIndustrySlice = createSlice({
  name: "coreIndustry",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch cases
      .addCase(fetchCoreIndustryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCoreIndustryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCoreIndustryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      // Add case
      .addCase(addCoreIndustryAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addCoreIndustryAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update case
      .addCase(updateCoreIndustryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCoreIndustryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.map((item) =>
          item.id === action.payload.id ? action.payload : item
        );
      })
      .addCase(updateCoreIndustryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete case
      .addCase(deleteCoreIndustryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCoreIndustryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((item) => item.id !== action.payload.id);
      })
      .addCase(deleteCoreIndustryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Selector
export const selectCoreIndustry = (state) => state.coreIndustry.data;

export default CoreIndustrySlice.reducer;
